
<collapsible-section
  class="collapse-item"
  :id="`objectModelRelationshipsCollapse-${objectModel.client_id}-${level}-${dropdownControlId}`"
  control-name="objectModelRelationshipsCollapse"
  :is-open="startOpened || isOpen(handler.hasObjectModelRelationshipMatch(lowerQ, objectModel))"
>
  <template #section-header>
    <row>
      <prefix>
        <icon glyph="relationships" />
      </prefix>
      <column> About Record </column>
    </row>
  </template>
  <template #section-contents>
    <field-item
      v-for="prop in handler.objectModelMetadataSection(lowerQ, objectModel)"
      :key="prop.clientIdOrId"
      :disabled="handler.isDisabled(prop, computedChildTreeContext)"
      @click="select(handler.metaDataSelect(prop, objectModel, completePathFor(prop)))">
      <row>
        <column>
          {{ prop.name }}
        </column>
      </row>
    </field-item>
  </template>
</collapsible-section>
